import {
  Control,
  Controller,
  FieldValues,
  Path,
  PathValue,
} from "react-hook-form";
// import { ErrorText } from "../common.style";
import DateInputField from "../DateInputField";
import { ErrorText } from "components/UI/common.style";

export type DateInputProps<TFieldValues extends FieldValues = FieldValues> = {
  name: string;
  control: Control<TFieldValues, any>;
  label: string;
  defaultValue?: string;
  id?: string;
  autoFocus?: boolean;
  inputLabelShrink?: boolean;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  helperText?: string;
  minDate?: string;
  maxDate?: string;
};

/** Primary UI component for date input field */
const DateInput = <TFieldValues extends FieldValues = FieldValues>({
  name,
  control,
  label,
  defaultValue,
  id,
  autoFocus,
  inputLabelShrink,
  disabled,
  required,
  placeholder,
  helperText,
  minDate,
  maxDate,
}: DateInputProps<TFieldValues>) => {
  return (
    <Controller
      name={name as Path<TFieldValues>}
      control={control}
      defaultValue={defaultValue as PathValue<TFieldValues, Path<TFieldValues>>}
      render={({
        field: { onChange, onBlur, value },
        formState: { errors },
      }) => {
        const errorMessage = errors[name]?.message ?? null;
        const hasError = typeof errors[name]?.message !== "undefined";

        return (
          <>
            {errorMessage && typeof errorMessage === "string" && (
              <ErrorText>{errorMessage}</ErrorText>
            )}
            <DateInputField
              onChange={onChange}
              onBlur={onBlur}
              label={label}
              value={value ?? defaultValue ?? ""}
              error={hasError}
              id={id ?? undefined}
              autoFocus={typeof autoFocus !== "undefined" ? autoFocus : false}
              inputLabelShrink={inputLabelShrink}
              disabled={disabled}
              required={required}
              placeholder={placeholder}
              helperText={hasError ? (errorMessage as string) : helperText}
              minDate={minDate}
              maxDate={maxDate}
            />
          </>
        );
      }}
    />
  );
};

export default DateInput;
